/* eslint-disable import/no-duplicates */
/* eslint-disable default-case */
import React, { useEffect } from 'react'
import { Suspense } from 'react'
import { ThemeProvider } from 'react-jss'
import { Provider as AtomProvider } from 'jotai'
import { BrowserRouter } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'
import Auth0 from './utils/Auth0'
import theme from './theme'
import Layout from './components/Layout'
import { Navbar } from './components/ui/Navbar/Navbar'
import './theme/global.css'
import { Lokalise } from './components/providers/Lokalise'
import { Spinner } from './components/ui/Loaders/Spinner'
import Interceptor from './api/Interceptor'
import RoleBasedRoutes from './RoleBasedRoutes'
import { logout } from './utils/Logout'

// 20 minutes.
const IDDLE_TIMEOUT = 1000 * 60 * 20

function App(): JSX.Element {
    const onIdle = (): void => {
        logout()
    }

    useIdleTimer({ onIdle, timeout: IDDLE_TIMEOUT })

    return (
        <BrowserRouter>
            <AtomProvider>
                <Suspense fallback={<Spinner />}>
                    <Lokalise>
                        <ThemeProvider theme={theme}>
                            <Interceptor>
                                <Layout>
                                    <Auth0>
                                        <>
                                            <Navbar />
                                            <RoleBasedRoutes />
                                        </>
                                    </Auth0>
                                </Layout>
                            </Interceptor>
                        </ThemeProvider>
                    </Lokalise>
                </Suspense>
            </AtomProvider>
        </BrowserRouter>
    )
}

export default App
